import {
  Component,
  EventEmitter,
  HostListener,
  Inject,
  Input,
  OnChanges,
  Output,
  SimpleChanges
} from '@angular/core';
import { IContact, LeadComposerChangesModel, LeadData, LeadsDataAction } from '../../../../models/leads/leads.model';
import { LEADS_DATA_SERVICE, LeadsDataService } from '../../../../services/leads/leads-data.service';
import { MatDialog } from '@angular/material/dialog';
import { ActionHelper } from '../../../../helper/action.helper';
import { DownloadHelper } from '../../../../helper/download.helper';
import { ActionIconHelper } from '../../../../helper/action-icon.helper';
import { OverlayHelper } from '../../../../helper/overlay.helper';

@Component({
  selector: 'fi-contact-actions',
  templateUrl: './contact-actions.component.html',
  styleUrls: ['./contact-actions.component.scss'],
  standalone: false,
})
export class ContactActionsComponent implements OnChanges {

  @Input() selectedLeadDetails: LeadData | undefined;
  @Input() mainLeadDetails: LeadData;
  @Input() isDuplicateLead: boolean;
  @Input() userId: number;
  @Input() mainLeadId: number;
  @Input() selectedContact: IContact;
  @Input() selectedLeadId: number;
  @Input() loadedLeadComposerOffers: LeadComposerChangesModel[] = [];

  @Output() duplicateChecked = new EventEmitter<void>();
  @Output() leadConnected = new EventEmitter<void>();
  @Output() actionCompleted = new EventEmitter<string>();
  @Output() actionRequested = new EventEmitter<{ action: LeadsDataAction, actonCallback: any }>();

  openAdditionalActions: boolean;
  hideAdditionalActions: boolean;
  actionsCount: number;

  constructor(
    @Inject(LEADS_DATA_SERVICE) private leadsDataService: LeadsDataService,
    private dialog: MatDialog,
  ) {

  }

  ngOnChanges( changes: SimpleChanges ): void {
    if (changes.selectedLeadDetails || changes.isDuplicateLead || changes.mainLeadDetails || changes.mainLeadId) {
      this.checkActionsCount();
    }
    if (changes.selectedLeadDetails) {
      this.setActionsIcons();
    }
  }


  @HostListener('document:click', ['$event'])
  onClick( ev: MouseEvent ): void {
    if ( ev.target instanceof HTMLElement && ev.target.closest('.menu, .additional-actions') ) {
      return;
    }

    this.openAdditionalActions = false;
  }

  doDuplicateAction(): void {
    const actionData = { leadId: this.mainLeadDetails.Lead.Id, fromDetailDuplicate: true };

    ActionHelper.showAction('DUPLICATE-CHECK', this.dialog, actionData)?.afterClosed().subscribe(value => {
      if ( value === 'update-mail' || value === 'existing' || value === 'imported' ) {
        this.duplicateChecked.emit();
      }
    });
  }

  openDeleteDialog(): void {
    this.onPopupClose();
    const actionData = {
      leadId: this.selectedLeadDetails.Lead.Id,
    };

    ActionHelper.showAction('DELETE-LEAD', this.dialog, actionData);
  }

  downloadLead(): boolean {
    return DownloadHelper.downloadLead(this.selectedLeadId, this.leadsDataService);
  }

  openLinkedDialog( label: string ): void {
    const actionData = {
      label,
      leadDetails: this.selectedLeadDetails?.Lead,
      contactDetails: this.selectedLeadDetails?.Contact ?? this.selectedContact,
    };
    ActionHelper.showAction('FI-LINK', this.dialog, actionData).afterClosed().subscribe(returnVal => {
      if ( returnVal ) {
        this.leadConnected.emit();
      }
    });
  }

  doAction( action: LeadsDataAction, successCallback?: () => void ): void {
    if ( action.Name === 'LEAD_CONNECT' ) {
      this.openLinkedDialog(action.Label);
      this.openAdditionalActions = false;
      return;
    }
    this.openAdditionalActions = false;
    this.onPopupClose();
    const result = ActionHelper.doAction({
      selectedLeadDetails: this.selectedLeadDetails,
      loadedLeadComposerOffers: this.loadedLeadComposerOffers,
      onAction: ( name, label, onActonCallback ) => {
        const action: LeadsDataAction = [this.selectedLeadDetails?.SuggestedAction, ...(this.selectedLeadDetails?.Actions ?? [])]
          .find(x => x?.Name === name) ?? { Id: -1, Name: name, Label: label, };

        this.actionRequested.emit({ action: action, actonCallback: onActonCallback });
      },

    }, action, this.dialog);

    result?.afterClosed().subscribe(data => {
      if ( data === 'remove' ) {
        this.actionCompleted.emit(action.Name);
        successCallback?.();
      }
    });
  }

  private setActionsIcons(): void {
    if ( this.selectedLeadDetails ) {

      this.selectedLeadDetails.actionIconUrl = this.getActionIcon(this.selectedLeadDetails.SuggestedAction?.Name);
      for ( const action of this.selectedLeadDetails.Actions ) {
        action.actionIconUrl = this.getActionIcon(action.Name)
      }
    }
  }

  private onPopupClose(): void {
    document.querySelector('body').classList.remove('open-mobile-popup');
    OverlayHelper.unfixBody();
  }

  private checkActionsCount(): void {
    this.actionsCount = this.getActionsCount();
    this.hideAdditionalActions = this.actionsCount > 1;
  }

  private getActionsCount(): number {
    let count = 0;

    if ( this.selectedLeadDetails?.Editor?.Inactive ) {
      return count;
    }

    if ( !this.isDuplicateLead && this.mainLeadDetails?.CanDelete ) {
      ++count;
    }


    if ( !this.isDuplicateLead && !this.selectedLeadDetails?.Editor?.Inactive && this.mainLeadId === this.selectedLeadDetails?.Lead.Id ) {
      ++count;
    }

    this.selectedLeadDetails?.Actions?.forEach(action => {
      if ( !action.Hidden && action.Name !== this.selectedLeadDetails?.SuggestedAction?.Name ) {
        ++count;
      }
    });

    return count;
  }

  private getActionIcon( name: string ): string {
    return ActionIconHelper.getActionIconUrl(name);
  }
}
